import React from 'react';
import { IAchPushDisbursementData } from '../../../../../types/order/escrow/IAchPushDisbursementData';
import { Table, Heading } from '@zillow/constellation';
import { useGetPaymentsData } from '../../hooks/useGetPaymentsData';
import { AchPushDisbursementRow } from './AchPushDisbursementsRow';

interface IAchPushDisbursementsContainerProps {
  achPushDisbursements: IAchPushDisbursementData[];
}

const tableHeaders = [
  'Fee Information',
  'Amount',
  'Category',
  'Spruce Account Label',
  'Spruce Account',
  'Receiving Party Name',
  'Receiving Party Account Type',
  'Receiving Party Account #',
  'Receiving Party Routing #',
  'Wells Fargo Transaction Number',
  'Sent At',
  'Disbursed At',
  'Confirmed At',
  'Voided At',
];

export const AchPushDisbursementsContainer: React.FC<IAchPushDisbursementsContainerProps> = ({
  achPushDisbursements,
}) => {
  const data = useGetPaymentsData(achPushDisbursements);

  return (
    <>
      <Heading level={1}>ACH Disbursements</Heading>
      <Table aria-label="ACH Disbursements" size={'sm'} appearance={'zebra'}>
        <Table.Header appearance="dark">
          <Table.Row>
            {tableHeaders.map((header) => (
              <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.map((item) => (
            <AchPushDisbursementRow key={item.id} item={item} />
          ))}
        </Table.Body>
      </Table>
    </>
  );
};
